/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import {
  mapGetters
} from 'vuex'; 
export default {
  name: 'user-details',
  components: {},
  props: [],
  data () {
    return {
      userDetails:{},
      userUpdates:{},
      userUpdatesList:[],
      loadmoreData: {},
      userLoading: false,
      nextStep:''
    }
  },
  computed: {
    ...mapGetters([
      'getMemberUserDetailsGetters',
      'getNuAcUpdatesListGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.getMemberUserDetailsGetters.data
    return
  },
  getUserUpdatesList(){
    this.userUpdates = this.$store.getters.getNuAcUpdatesListGetters.data
    return
  },
  setInitialStates(){
    if(this.userUpdates != undefined){
      this.nextStep = this.userUpdates.next
      this.userUpdatesList = this.userUpdates.results
    }
  }
  },
  mounted () {
    this.getUserDetailsAgainFun
    this.getUserUpdatesList
    this.setInitialStates
  },
  methods: {
    showLoadMoreDataFun(url) {
      this.userLoading = true
      console.log(url, "Next URL LINK")
      axios.get(url).then((response) => {
        console.log(response.data.data.next)
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.userUpdatesList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userUpdatesList.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.getMemberUserDetailsGetters.data
    },
    getUserUpdatesList(){
      return this.$store.getters.getNuAcUpdatesListGetters.data
    },
    setInitialStates(){
      if(this.userUpdates != undefined){
        this.nextStep = this.userUpdates.next
        this.userUpdatesList = this.userUpdates.results
      }
    }
  },
}